import mrApi from './mrApi';

export default {
  getData
};

export function getData(params) {
  return mrApi.get('/api/dataToolSvc/getData', { params });
}